module.exports = __webpack_public_path__ + "img/J11794.4fac46e4.png";